module.exports = __webpack_public_path__ + "static/media/ash_expansion.7032e8bc.svg";